import { FC, ReactNode } from 'react';

interface Props {
   image: string;
   showOverlay?: boolean;
   inline?: boolean;
   children?: ReactNode;
}

export const Banner: FC<Props> = ({ image, showOverlay = true, inline = false, children }) => (
   <div data-testid="banner-container" style={{ backgroundImage: `url(${image})` }} className={`h-fit overflow-hidden bg-cover bg-center ${inline && 'rounded-component-layout-box-border-radius-largest'}`.replace(/\s+/g, ' ')}>
      <div data-testid="banner-overlay" className={`flex justify-center ${showOverlay && 'bg-component-surfaces-overlay-container-color-background-scrimmed-primary'}`.replace(/\s+/g, ' ')}>
         {inline ? (
            <div data-testid="banner-content--inline" className="p-component-layout-box-spacing-padding-xl phone:p-component-layout-box-spacing-padding-md relative z-10 box-content size-full">
               {children}
            </div>
         ) : (
            <div data-testid="banner-content--full" className="p-component-layout-box-spacing-padding-xl relative z-10 box-content w-full">
               <div data-testid="banner-content-container" className="container h-full">
                  {children}
               </div>
            </div>
         )}
      </div>
   </div>
);
